export const environment = {
  userKey: 'no_good_to_be_curious',
  baseUrl: 'http://kanekoinformatica.com.br/biofermentosAPI',
//   baseUrl: 'http://192.168.200.99/biofermentosAPI'
};



// WEBPACK FOOTER //
// ./src/environment/environment.ts